/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Waitlist_FailInputs */

const en_booking_waitlist_fail = /** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not join waitlist.`)
};

const es_booking_waitlist_fail = /** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo unirte a la lista.`)
};

const fr_booking_waitlist_fail = /** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de rejoindre la liste d'attente.`)
};

const de_booking_waitlist_fail = /** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konnte der Warteliste nicht beitreten.`)
};

const id_booking_waitlist_fail = /** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat bergabung dengan daftar tunggu.`)
};

/** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */
const ja_booking_waitlist_fail = en_booking_waitlist_fail;

/** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */
const zh_booking_waitlist_fail = en_booking_waitlist_fail;

/** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */
const ar_booking_waitlist_fail = en_booking_waitlist_fail;

/** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */
const it_booking_waitlist_fail = en_booking_waitlist_fail;

/** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */
const ru_booking_waitlist_fail = en_booking_waitlist_fail;

/** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */
const pt_booking_waitlist_fail = en_booking_waitlist_fail;

/** @type {(inputs: Booking_Waitlist_FailInputs) => LocalizedString} */
const ko_booking_waitlist_fail = en_booking_waitlist_fail;

/**
* | output |
* | --- |
* | "Could not join waitlist." |
*
* @param {Booking_Waitlist_FailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_waitlist_fail = /** @type {((inputs?: Booking_Waitlist_FailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Waitlist_FailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_waitlist_fail(inputs)
	if (locale === "es") return es_booking_waitlist_fail(inputs)
	if (locale === "fr") return fr_booking_waitlist_fail(inputs)
	if (locale === "de") return de_booking_waitlist_fail(inputs)
	if (locale === "ja") return ja_booking_waitlist_fail(inputs)
	if (locale === "zh") return zh_booking_waitlist_fail(inputs)
	if (locale === "ar") return ar_booking_waitlist_fail(inputs)
	if (locale === "id") return id_booking_waitlist_fail(inputs)
	if (locale === "it") return it_booking_waitlist_fail(inputs)
	if (locale === "ru") return ru_booking_waitlist_fail(inputs)
	if (locale === "pt") return pt_booking_waitlist_fail(inputs)
	return ko_booking_waitlist_fail(inputs)
});